<template>
  <v-autocomplete
    :class="`ep-combobox ep-combobox-${valid ? 'valid' : 'invalid'}`"
    :style="{
      height: '50px',
      borderRadius: '8px',
      boxShadow: 'none'
    }"
    :tabindex="field.tabIndex"
    :items="choices"
    item-text="name"
    :loading="field.loading"
    :placeholder="field.placeholder"
    outlined
    persistent-hint
    :value="value"
    v-bind="$attrs"
    v-on="$listeners"
  ></v-autocomplete>
</template>

<script>
import _ from "lodash";

export default {
  name: "ComboBox",

  props: ["field", "valid", "value"],

  computed: {
    choices() {
      const { choices } = this.field;

      if (_.isFunction(choices)) {
        return choices(this.value);
      }

      return choices;
    }
  },

  watch: {
    ["field.selected"](selectedIndex) {
      if (
        !_.isNumber(selectedIndex) ||
        selectedIndex < 0 ||
        selectedIndex >= this.choices?.length
      ) {
        return;
      }

      const selectedField = this.choices[selectedIndex];

      if (selectedField) {
        this.$emit("input", selectedField.name);
      }
    }
  }
};
</script>

<style lang="scss">
.ep-combobox {
  fieldset {
    border-color: #e0e0e0 !important;
    background-color: white !important;
  }
}

.ep-combobox-invalid {
  fieldset {
    border-color: #ff0000 !important;
    background-color: #ffafaf !important;
  }
}
</style>
